import { useEffect, useState } from "react";
import axios from "axios";
import { Grid, TextField, Button, Divider } from "@mui/material";
import jsPDF from "jspdf";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";

const StyledDateField = styled(TextField)({
    width: "220px",
    maxWidth: "100%",
    "& .MuiInputBase-input": {
        height: "38px !important",
        fontSize: "20px",
        color: "#002855",
        fontWeight: 500,
        WebkitTextFillColor: "#002855",
        fontFamily: "Inter, Arial, Helvetica, sans-serif !important",
    },
    "& .MuiOutlinedInput-root": {
        position: "relative",
        fontFamily: "Inter, Arial, Helvetica, sans-serif !important",

        "& fieldset": {
            borderColor: "#002855",
            borderWidth: "1px",
        },
        "&:hover fieldset": {
            borderColor: "#002855",
            borderWidth: "1px",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#002855",
            borderWidth: "1px",
        },
        "&::after": {
            content: '""',
            position: "absolute",
            left: 0,
            bottom: 0,
            width: "100%",
            borderBottom: "1px solid #002855",
            transition: "all 0.2s ease",
            pointerEvents: "none",
        },
        "&:hover::after": {
            borderBottom: "4px solid #002855",
        },
        "&.Mui-focused::after": {
            borderBottom: "4px solid #002855",
        },
    },

    "& .MuiSvgIcon-root": {
        color: "#002855",
    },
});

const rootStyles = {
    width: "220px",
    maxWidth: "100%",
    marginTop: "5px",
    "& label": { display: "none" },
    "& legend": { display: "none" },
    "& .MuiInputBase-input": {
        color: "#002855",
        fontWeight: 400,
        WebkitTextFillColor: "#002855",
        fontFamily: "Inter, Arial, Helvetica, sans-serif",
        fontSize: "20px",
    },
    "& .MuiOutlinedInput-root": {
        height: "52px !important",
        fontFamily: "Inter, Arial, Helvetica, sans-serif",
        "& fieldset": {
            borderColor: "#002855",
            borderWidth: "1px",
        },
        "&:hover fieldset": {
            borderColor: "#002855",
            borderWidth: "1px",
            borderBottom: "4px solid #002855",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#002855",
            borderWidth: "1px",
            borderBottom: "4px solid #002855",
        },
    },
    "& .MuiOutlinedInput-root.Mui-error": {
        "& fieldset": {
            borderColor: "#ac343d !important",
            borderBottom: "4px solid #ac343d !important",
        },
        "&:hover fieldset": {
            borderColor: "#002855 !important",
            borderWidth: "1px !important",
            borderBottom: "4px solid #002855 !important",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#002855",
            borderWidth: "1px",
            borderBottom: "4px solid #002855 !important",
        },
    },
    "& .MuiFormHelperText-root.Mui-error": {
        fontSize: "16px",
        display: "block",
        fontWeight: 400,
        marginBottom: "12px",
        paddingTop: "8px",
        order: 1,
        color: "#ac343d",
        marginLeft: "7px !important",
        textDecoration: "underline",
    },
    "& .MuiFormHelperText-root": {
        marginLeft: "0px !important",
        paddingTop: "0px !important",
    },
};

export default function Housing() {
    const [filterModel, setFilterModel] = useState("");
    const [notFoundMsg, setNotFoundMsg] = useState("");
    const [installDate, setInstallDate] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [errors, setErrors] = useState({});
    const [items, setItems] = useState([]);
    const [rows, setRows] = useState([]);

    const OnFormatDate = (date) => {
        return !date ? "" : dayjs(date).format("DD/MM/YYYY");
    };

    const addMonths = (date, months) => {
        if (!date || !months) return null;
        return dayjs(date).add(Number(months), "month").toDate();
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const url =
                "https://394d69e74781469581cab91049348b.91.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/9a7539f9209947d2b0ca966f5ab050aa/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=OH3ZYXCfci17SIJjKKLtKzqBLQfsr3E3_kO_d2bAc3E";

            const response = await axios.post(
                url,
                { Type: "Housing" },
                {
                    headers: { "Content-Type": "application/json" },
                },
            );

            console.log(response);
            setItems(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const validateForm = () => {
        const newErrors = {};
        let isValid = true;

        if (!filterModel.trim()) {
            newErrors.filterModel = "Filter Model is required";
            isValid = false;
        }

        if (!installDate) {
            newErrors.installDate = "Installation Date is required";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setShowDetails(false);
        setNotFoundMsg("");

        if (!validateForm()) {
            return;
        }

        const filtered = items.filter((item) => item.Title?.toLowerCase() === filterModel.toLowerCase());

        if (filtered.length === 0) {
            setNotFoundMsg("Model number not found");
            return;
        }

        const data = filtered[0];

        const generatedRows = [
            {
                modelLabel: "Element Model",
                modelValue: data.ReplacementElement,
                dateLabel: "Replacement Date",
                replacementDate: data.ElementChangeOutPeriod && data.ElementChangeOutPeriod !== "NA" ? addMonths(installDate, data.ElementChangeOutPeriod) : null,
            },
            {
                modelLabel: "Drain Model",
                modelValue: data.DrainModel,
                dateLabel: "Replacement Date",
                replacementDate: data.DrainChageOutPeriod && data.DrainChageOutPeriod !== "NA" ? addMonths(installDate, data.DrainChageOutPeriod) : null,
            },
        ];

        if (data.ReplacementElement2) {
            generatedRows.splice(1, 0, {
                modelLabel: "Element Model",
                modelValue: data.ReplacementElement2,
                dateLabel: "Replacement Date",
                replacementDate: data.ElementChangeOutPeriod2 && data.ElementChangeOutPeriod2 !== "NA" ? addMonths(installDate, data.ElementChangeOutPeriod2) : null,
            });
        }

        setRows(generatedRows);
        setShowDetails(true);
    };

    const isOverdue = (date) => {
        if (!date) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);

        return checkDate < today;
    };

    const exportToPDF = () => {
        const doc = new jsPDF("p", "mm", "a4");

        const pageHeight = 297;
        const marginX = 15;
        const footerSpace = 20;

        let y = 70;
        const primaryColor = [0, 0, 0];

        const lightGray = [230, 233, 237];
        const textGray = [120, 120, 120];

        const reportDate = moment(new Date()).format("DD/MM/YYYY");

        const headerImage = require("../src/assests/ReportLogo.png");

        // HEADER + FOOTER
        const addHeaderFooter = () => {
            doc.addImage(headerImage, "PNG", 13, 5, 50, 18);

            const footerY = pageHeight - 12;

            doc.setFont("helvetica", "normal");
            doc.setFontSize(6);
            doc.setTextColor(...textGray);

            doc.text("Walker Filtration Ltd", marginX, footerY - 10);
            doc.text("Birtley Road, Washington, Tyne & Wear, NE38 9DA, UK", marginX, footerY - 7);
            doc.text("tel +44 (0) 191 417 7816   fax +44 (0) 191 415 3748", marginX, footerY - 3);
            doc.text("email sales@walkerfiltration.com   web www.walkerfiltration.com", marginX, footerY);
            doc.text("Registered in England No. 1726079 | VAT Reg No. 389 6267 87", marginX + 65, footerY);
        };

        addHeaderFooter();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(20);
        doc.setTextColor(...primaryColor);
        doc.text("Recommended Serviceable Parts", marginX, 40);

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(...primaryColor);
        doc.text(`Filter Model: ${filterModel}`, marginX, 47);
        doc.text(`Installation Date: ${OnFormatDate(installDate)}`, marginX, 53);
        doc.text(`Report Date: ${reportDate}`, marginX, 59);

        // 🔥 TABLE HEADER
        doc.setFillColor(...lightGray);
        doc.rect(marginX, y, 180, 8, "F");

        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);

        doc.text("Part Name", marginX + 2, y + 5);
        doc.text("Code", marginX + 80, y + 5);
        doc.text("Replacement Date", marginX + 130, y + 5);

        y += 10;
        const sections = [
            {
                title: "Components",
                items: rows,
            },
        ];

        sections.forEach((section) => {
            if (section.items.length === 0) return;

            // 🔥 PAGE BREAK CHECK
            if (y > pageHeight - footerSpace) {
                doc.addPage();
                addHeaderFooter();
                y = 70;
            }

            y += 8;

            section.items.forEach((row) => {
                if (y > pageHeight - footerSpace) {
                    doc.addPage();
                    addHeaderFooter();
                    y = 70;
                }

                doc.setFont("helvetica", "normal");
                doc.setFontSize(12);
                doc.setTextColor(0, 0, 0);

                doc.text(row.modelLabel, marginX + 2, y);
                doc.text(row.modelValue || "-", marginX + 80, y);
                doc.text(OnFormatDate(row.replacementDate), marginX + 130, y);

                y += 6;

                // 🔥 DISCLAIMER
                if (row.disclaimerValue) {
                    doc.setFontSize(9);
                    doc.setTextColor(...textGray);

                    const splitText = doc.splitTextToSize("• " + row.disclaimerValue, 160);

                    doc.text(splitText, marginX + 5, y);

                    y += splitText.length * 4;

                    doc.setFontSize(12);
                    doc.setTextColor(0, 0, 0);
                }

                y += 2;

                // 🔥 LINE
                doc.setDrawColor(200);
                doc.line(marginX, y, marginX + 180, y);

                y += 10;
            });
        });

        doc.save("Recommended Serviceable Parts.pdf");
    };
    return (
        <div className="mt-3 pt-3">
            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 2, lg: 2 }} className="mb-4 align-items-top">
                <Grid item size={{ xs: 12, sm: 3, md: 2, lg: 2 }} className="gridAlignBottom">
                    <span className="feildLabel">Filter Model</span>
                    <span className="required">*</span>
                </Grid>
                <Grid item size={{ xs: 12, sm: 3, md: 2.5, lg: 2.3 }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div className="gridAlignBottom">
                            <TextField
                                size="small"
                                value={filterModel}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setFilterModel(value);
                                    if (value.trim()) {
                                        setErrors((prev) => ({
                                            ...prev,
                                            filterModel: "",
                                        }));
                                    }
                                }}
                                sx={{ ...rootStyles }}
                                error={!!errors.filterModel}
                                helperText={""}
                                placeholder="A30006XA"
                            />
                        </div>
                        <span className="errorText">{errors.filterModel}</span>
                    </div>
                </Grid>

                <Grid item size={{ xs: 12, sm: 3, md: 2, lg: 2 }} className="gridAlignBottom">
                    <span className="feildLabel">Installation Date</span>
                    <span className="required">*</span>
                </Grid>

                <Grid item size={{ xs: 12, sm: 2, md: 2.5, lg: 2.3 }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div className="gridAlignBottom">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DesktopDatePicker
                                    enableAccessibleFieldDOMStructure={false}
                                    desktopModeMediaQuery="@media (pointer: coarse)"
                                    value={installDate}
                                    onChange={(newValue) => {
                                        setInstallDate(newValue);
                                    }}
                                    format="DD/MM/YYYY"
                                    slots={{
                                        textField: StyledDateField,
                                    }}
                                    slotProps={{
                                        dialog: {
                                            sx: {
                                                "& .MuiDateCalendar-root": {
                                                    width: "230px !important",
                                                    maxHeight: "300px !important",
                                                },
                                            },
                                        },
                                        popper: {
                                            sx: {
                                                "& .MuiDateCalendar-root": {
                                                    width: "230px !important",
                                                    maxHeight: "300px !important",
                                                },
                                            },
                                        },

                                        textField: {
                                            size: "small",
                                            error: !!errors.installDate,
                                            helperText: "",
                                            sx: {
                                                "& .MuiFormHelperText-root.Mui-error": {
                                                    fontSize: "16px",
                                                    display: "block",
                                                    fontWeight: "400 !important",
                                                    marginBottom: "12px",
                                                    paddingTop: "8px",
                                                    order: 1,
                                                    color: "#ac343d",
                                                    marginLeft: "7px !important",
                                                    textDecoration: "underline",
                                                    height: "40px !important",
                                                },
                                                "& .MuiDateCalendar-root": {
                                                    width: "230px !important",
                                                    maxHheight: "300px !important",
                                                },
                                                "& .MuiFormHelperText-root": {
                                                    marginLeft: "0px !important",
                                                    paddingTop: "0px !important",
                                                    fontFamily: "Inter, Arial, Helvetica, sans-serif",
                                                },

                                                "& .MuiOutlinedInput-root.Mui-error": {
                                                    "& fieldset": {
                                                        borderColor: "#ac343d !important",
                                                        borderBottom: "4px solid #ac343d !important",
                                                    },

                                                    "&:hover fieldset": {
                                                        borderColor: "#002855 !important",
                                                        borderWidth: "1px !important",
                                                        borderBottom: "4px solid #002855 !important",
                                                    },

                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "#002855",
                                                        borderWidth: "1px",
                                                        borderBottom: "4px solid #002855 !important",
                                                    },

                                                    "&::after": {
                                                        borderBottom: "1px solid #ac343d !important",
                                                    },

                                                    "&:hover::after": {
                                                        borderBottom: "4px solid #002855 !important",
                                                    },
                                                },
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>

                        <span className="errorText">{errors.installDate}</span>
                    </div>
                </Grid>

                <Grid item size={{ xs: 12, sm: 3, md: 2, lg: 2 }} className="gridAlignBottom">
                    <Button variant="contained" onClick={handleSubmit} className="button">
                        Check Details
                    </Button>
                </Grid>
            </Grid>

            {showDetails && (
                <div className="scrollWrapper">
                    <Divider
                        sx={{
                            marginTop: "10px",
                            marginBottom: "20px",
                            borderColor: "#A1A9B4",
                        }}
                    />

                    {rows.map((row, index) => (
                        <Grid container key={index} rowSpacing={{ xs: 2, sm: 2, md: 2, lg: 2 }} columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }} className="mb-4" alignItems={"flex-end"}>
                            <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2 }} className="detailsStyles">
                                {row.modelLabel}
                            </Grid>

                            <Grid item size={{ xs: 12, sm: 12, md: 2.5, lg: 2.3 }} className="detailsStyles">
                                {row.modelValue}
                            </Grid>

                            <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2 }} className="detailsStyles">
                                {row.dateLabel}
                            </Grid>

                            <Grid item size={{ xs: 12, sm: 12, md: 2.5, lg: 2.3 }} className="detailsStyles">
                                <span
                                    style={{
                                        color: isOverdue(row.replacementDate) ? "#b03f47" : "#002855",
                                        fontWeight: isOverdue(row.replacementDate) ? "500" : "400",
                                    }}
                                >
                                    {OnFormatDate(row.replacementDate)}
                                </span>
                            </Grid>

                            <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2 }} className={index === rows.length - 1 ? "lastRowAlign" : ""}>
                                {row.disclaimerValue && <div style={{ fontSize: "12px", color: "#002855", fontFamily: "Inter, Arial, Helvetica, sans-serif" }}>{row.disclaimerValue}</div>}
                                {index === rows.length - 1 && (
                                    <Button size="small" variant="contained" className="button" onClick={exportToPDF}>
                                        Export to PDF
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    ))}
                </div>
            )}

            {notFoundMsg && <div style={{ color: "red", marginTop: "10px", fontWeight: 500 }}>{notFoundMsg}</div>}
        </div>
    );
}
